import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.alert_form', () => {
  void import('./internal/alert_form').then(({ default: Component }) => Component());
});
